import React from 'react';
import { Wrench, ThumbsUp } from 'lucide-react';
import { wpMedia } from '../utils/wpMedia';

export const TrustBadges = () => {
  return (
    <section className="py-10 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">

          {/* WQA Member Logo */}
          <div className="flex flex-col items-center gap-2">
            <img
              src={wpMedia('2026/06/wqa-logo-scaled.png')}
              alt="Water Quality Association Member"
              className="h-16 w-auto object-contain"
            />
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">WQA Member</span>
          </div>

          <div className="hidden md:block w-px h-12 bg-gray-200" aria-hidden="true" />

          <div className="flex flex-col items-center gap-2">
            <img
              src={wpMedia('2026/06/MWS_Color.jpg')}
              alt="Master Water Specialist"
              className="h-16 w-auto object-contain"
            />
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Certified</span>
          </div>

          <div className="hidden md:block w-px h-12 bg-gray-200" aria-hidden="true" />

          {/* Professional Installation */}
          <div className="flex flex-col items-center gap-2 text-center">
            <div className="p-3 rounded-full" style={{ backgroundColor: '#E3F2FD' }}>
              <Wrench className="h-8 w-8" style={{ color: '#1571BA' }} />
            </div>
            <div>
              <p className="font-bold text-slate-900 text-sm">Professional Installation</p>
              <p className="text-xs text-gray-500">Qualified Plumber</p>
            </div>
          </div>

          <div className="hidden md:block w-px h-12 bg-gray-200" aria-hidden="true" />

          <div className="flex flex-col items-center gap-2 text-center">
            <div className="p-3 rounded-full" style={{ backgroundColor: '#E3F2FD' }}>
              <ThumbsUp className="h-8 w-8" style={{ color: '#1571BA' }} />
            </div>
            <div>
              <p className="font-bold text-slate-900 text-sm">Reliable Service</p>
              <p className="text-xs text-gray-500">Service Requests</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
